// extracted by mini-css-extract-plugin
export default {"card":"Card_card__oym0C","cardDrawn":"Card_cardDrawn__Jm1Bv","cardClosed":"Card_cardClosed__uGsWS","draw":"Card_draw__kQL8s"};